<template>
  <div>
    <slot/>
  </div>
</template>

<script>
    export default {
      props:{
        data:Object,
        prop:{type:String,default:''},// 表头的key值，根据用户输入展示对应的value
        label:{type:String,default:''},// 要展示的表头
        width:{type:Number},// 每列的宽，默认60,
      },
      data(){
        return{
          dataList:[],
        }
      },
      created(){
        console.log(this.data);
      },
      mounted(){
          // let data = this.$store.state.data;
          // console.log(data);
          this.$store.commit('New_Props',this.prop);
          this.$store.commit('New_Labels',this.label);
          this.$store.commit('New_Width',this.width);
      },
      // methods:{
      //   jsonChangeMap(map){// json对象转为map集合
      //     let strMap = new Map();
      //     for(let k of Object.keys(map)){
      //       strMap.set(k,map[k]);
      //     }
      //     return strMap;
      //   },
      //   getMapKeysList(strMap){// 获取map的key添加到数组中
      //     let keys = [];
      //     for(let key of strMap.keys()){
      //       keys.push(key);
      //     }
      //     return keys;
      //   }
      // },
      // created(){
      //   let dataList = this.$store.state.data;
      //   this.dataList = dataList;
      //   for(let i =0 ;i<1;i++){
      //     let map = dataList[0];
      //     let strMap = this.jsonChangeMap(map);
      //     let keys = [];
      //     keys = this.getMapKeysList(strMap);
      //     console.log(keys);
      //     this.titleData = keys;
      //   }
      // }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tableItem.vue